import { Fragment, useContext } from "react";
import { classNames } from "utils/class";

import logo from "assets/images/logo2.png";
import avatar from "assets/images/no-avatar.png";
import { logout } from "backend/auth";
import { Menu, Transition } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import { AuthContext, User } from "Auth";

export default function Navbar() {
    const navigate = useNavigate();
    const user: User = useContext(AuthContext);

    const goProfile = () => {
        navigate("/profile");
    };

    const goHome = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        navigate("/");
    };

    return (
        <header className="w-full bg-white shadow-sm">
            <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
                <div className="flex h-16 justify-between items-center">
                    <a href="#login" onClick={goHome}><img src={logo} alt="Logo" width={180} /></a>
                    <Menu as="div" className="relative ml-3">
                        <div>
                            <Menu.Button className="flex items-center gap-2 rounded-full bg-white text-sm focus:outline-none focus:ring-0">
                                <span className="text-gray-500 text-sm">Hello, <b className="text-gray-800">{user.uid}</b></span>
                                <img
                                    className="h-8 w-8 rounded-full"
                                    src={user.photoURL ? `${user.photoURL}&width=32` : avatar}
                                    height={32}
                                    width={32}
                                    alt="Avatar"
                                />

                            </Menu.Button>
                        </div>
                        <Transition
                            as={Fragment}
                            enter="transition ease-out duration-200"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                        >
                            <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                <Menu.Item>
                                    {({ active }) => (
                                        <button
                                            className={classNames(
                                                active ? "bg-gray-100" : "",
                                                "flex w-full px-4 py-2 text-sm text-gray-700"
                                            )}
                                            onClick={goProfile}
                                        >
                                            Profile
                                        </button>
                                    )}
                                </Menu.Item>
                                <Menu.Item>
                                    {({ active }) => (
                                        <button
                                            className={classNames(
                                                active ? "bg-gray-100" : "",
                                                "flex w-full px-4 py-2 text-sm text-gray-700"
                                            )}
                                            onClick={logout}
                                        >
                                            Sign out
                                        </button>
                                    )}
                                </Menu.Item>
                            </Menu.Items>
                        </Transition>
                    </Menu>
                </div>
            </div>
        </header>
    );
}
